import { render, staticRenderFns } from "./qyModel.vue?vue&type=template&id=8c4247a2&scoped=true&"
import script from "./qyModel.vue?vue&type=script&lang=js&"
export * from "./qyModel.vue?vue&type=script&lang=js&"
import style0 from "./qyModel.vue?vue&type=style&index=0&id=8c4247a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4247a2",
  null
  
)

export default component.exports